var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multi-line"},[_c('span',[_vm._v(_vm._s(_vm.effectCount)+" "+_vm._s(_vm.effect.type))]),_c('span',{class:{ dashed : _vm.effectCount.length },style:({ color: '#8E8E8F'})},[_vm._v(_vm._s(_vm.getLine))])])
}
var staticRenderFns = []

export { render, staticRenderFns }